import React, { useEffect } from 'react';
import { useAxiosEx } from '../DataLoader';

export function useSearchCache() {
    const [{ data: jiraSearchData, loading: loadingJira }, refetchJira] = useAxiosEx(`/api-jira/search?search=*`, { manual: true });
    const [{ data: sapSearchData, loading: loadingSap }, refetchSap] = useAxiosEx(`/api-sap/db/live/master-data-flat`, { manual: true });

    useEffect(() => {
        if (process.env.NODE_ENV !== 'development') {
            setTimeout(() => {
                void refetchJira();
                void refetchSap();
            }, 4000);
        }
    }, [refetchJira, refetchSap]);

    function tranformSapData(data: any[]) {
        data.forEach((item: any) => {
            item.searchResult = 'sap item';
            item.label = `${item.ItemCode} - ${item.ItemName}`;
            item.keywords = [item.ItemCode, item.ItemName].map((x) => x?.toLowerCase());
            item.sublabel =
                item.InvntItem === 'Y' ? (
                    <React.Fragment>
                        MPN: {item.MPN} Mnf: {item.FirmName} OnHand: {item.OnHand} OnOrder: {item.OnOrder} IsCommited: {item.IsCommited}{' '}
                        <span className={item.IsAvailable > 0 ? 'fw-bold text-success' : ''}>IsAvailable: {item.IsAvailable}</span>
                        <br />
                        {item.IsDeprecated === 'Y' ? <span className="text-danger fw-bold">DEPRECATED ITEM</span> : null}
                    </React.Fragment>
                ) : (
                    'Non Inventory Item'
                );
            item.link = null;
            item.image = `${process.env.PUBLIC_URL}/SAPImages/${item.ItemCode}.jpg`;
        });
    }

    const searchData = React.useMemo(() => {
        tranformSapData(sapSearchData ?? []);
        return [...(jiraSearchData ?? []), ...(sapSearchData ?? [])];
    }, [jiraSearchData, sapSearchData]);

    return [{ data: searchData ?? [], loading: loadingJira || loadingSap }];
}
